const formatDate = (date) => {
  const splitDate = date.substring(0, 10).split('-');

  const day = splitDate[2];
  const month = splitDate[1];
  const year = splitDate[0];

  return `${day}-${month}-${year}`;
};

export const stampToHuman = (timestamp) => new Date(timestamp * 1000).toLocaleString().split(',')[0];

export const dateFromAcf = (date) => {
  const year = date.substring(0, 4);
  const month = date.substring(4, 6);
  const day = date.substring(6, 8);

  return `${day}/${month}/${year}`;
};

export const timeFromAcf = (time) => {
  const hour = time.substring(0, 2);
  const minute = time.substring(3, 5);

  return `${hour}:${minute}`;
};

export const isoToCatalan = (time) => {
  const data = new Date(time);
  const nomsMesos = [
    'gener',
    'febrer',
    'març',
    'abril',
    'maig',
    'juny',
    'juliol',
    'agost',
    'setembre',
    'octubre',
    'novembre',
    'desembre',
  ];
  const dia = data.getDate();
  const mes = nomsMesos[data.getMonth()];
  const any = data.getFullYear();
  return `${dia} de ${mes} del ${any}`;
};

export default formatDate;
